import React from 'react';

import classNames from "classnames";
import styles from "../../styles/language-menu.module.scss";

export const LanguageMenuModuleHeaderTitle = ({controller}) => {
  const {state, terms} = controller;
  const {menuModel} = state;
  const {WEB_LANG_MENU_HEADER} = terms;
  const {showSelectedLanguageLabel} = menuModel;

  return showSelectedLanguageLabel ? <div className={classNames(styles.header_title)}>{WEB_LANG_MENU_HEADER}</div> : null
};
